import CustomCheckBoxes from './converters/checkboxes'
import CustomSoftBreak from './converters/normalizeSoftBreak'
import CustomSignature from './converters/signature'
import ImportNotesTemplate from './import-notes-template/importNotesTemplate'
import Placeholder from './placeholder/placeholder'

export type CustomPluginName =
  | 'CustomCheckBoxes'
  | 'CustomSignature'
  | 'CustomSoftBreak'
  | 'ImportNotesTemplate'
  | 'Placeholder'

export {
  CustomCheckBoxes,
  CustomSignature,
  CustomSoftBreak,
  ImportNotesTemplate,
  Placeholder,
}

export const CustomPluginNames: CustomPluginName[] = [
  'CustomCheckBoxes',
  'CustomSignature',
  'CustomSoftBreak',
  'ImportNotesTemplate',
  'Placeholder',
]

export const CustomPlugins = [
  CustomCheckBoxes,
  CustomSignature,
  CustomSoftBreak,
  ImportNotesTemplate,
  Placeholder,
]
